const statusValidationValues = [
  '1. En recherche',
  '2. En relance recherche',
  '2.1 Bilan de zone',
  '3. Validation en cours',
  '4.1 En attente CRVT/Visée/Pano',
  '4.2 En attente CRVT',
  '4.3 CRVT à valider (MOE SFR)',
  '4.4 En attente reprise CRVT',
  '5. En attente validation des visées FH',
  '6. En attente MAJ coordonnées RSU',
  '7. Prospect validé',
  '8. Abandonné',
  'à valider',
  'Prospect KO',
  'MAV à déposer',
  'Abandonné',
  'En Recherche',
  'En Relance Recherche',
  'Validation En Cours',
  'En attente PANO',
  'En attente visées FH',
  'En attente validation des visées FH',
  'En attente MAJ coordonnées RSU / CRVT',
  'En attente DC',
  'Prospect Validé',
  'GO CONSTR SFR',
];
const statusSfrValues = [
  '0.Bloquée/Suspendu MAD',
  '0.Bloquée/Suspendu Conv',
  '1.En Recherche',
  '2.En validation',
  '3.Validé',
  '3.En Conception',
  '4.En cours conception',
  '4.GO Constr. Anticipé',
  '5.En attente visées FH',
  '5.GO Constructibilité',
  '6.GO Constructibilité',
  '7.GO Constructibilité Anticipé',
  '7.MES',
  '8.Annulé',
  '8.PEM',
  'En service',
];
export { statusValidationValues, statusSfrValues };
